import React, { useEffect, useState } from "react";
import withRouter from "../../custom/withRouter";
import Pagination from "react-js-pagination";
import { connect } from "react-redux";
import downArrow from "../../../assets/svg/downarrow.svg";
import upArrow from "../../../assets/svg/uparrow.svg";
import AddIcon from "../../../assets/svg/addIcon.svg";
import Autocomplete from "react-autocomplete";
import arrowright from "../../../assets/svg/arrow-right.svg";
import arrowleft from "../../../assets/svg/arrow-left.svg";
import Select from "react-select";
import RemoveIcon from "../../../assets/svg/removeIcon.svg";
import API from "../../../helpers/endpointService";
import axios from "axios";
import DownArrowIcon from "../../../assets/svg/downarrow.svg";
// import CommonSearch from "../..//pages/search/Search";
import EditIcon from "../../../assets/svg/editIcon.svg";
import DateIcon from "../../../assets/svg/date.svg";
import SubCategoryIcon from "../../../assets/svg/smallcategory.svg";
import UpArrowIcon from "../../../assets/svg/uparrow.svg";
import LeftArrowIcon from "../../../assets/svg/LeftArrow.svg";
import RightArrowIcon from "../../../assets/svg/RightArrow.svg";
import WarningIcon from "../../../assets/svg/warningIcon.svg";
import { PulseLoader } from "react-spinners";
import ButtonSubmitIcon from "../../../assets/svg/submitbuttonIcon.svg";
import CrossIcon from "../../../assets/svg/crossIcon.svg";
import ReactPaginate from "react-paginate";
import LedgerIcon from "../../../assets/svg/ledgermaxIcon.svg";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import { logoutFunction } from "../../custom/commonFunction";
import moment from "moment";

const paginglist = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
];
const paginglistDefault = [{ label: "20", value: 20 }];

var SelectedValue = false;

class Ledger extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "category1Name",
      height: window.innerHeight,
      isLedgerFailed: false,
      isLedgerLoader: false,
      isMobile: false,
      isSmallMobile: false,
      isRadioMobile: false,
      isCancelMobile: false,
      ledgerArryList: [],
      categoryArrayList: [],
      ledgerList: undefined,
      category1Error: false,
      category2Error: false,
      documentFormatError: false,
      LedgerDetails: {
        id: 0,
        category1Name: "",
        category2Name: "",
        category1Id: "",
        category2Id: "",
        documentId: 0,
        documentFormat: "",
        numberFormat: "",
      },
      AddLedgerDetails: {
        id: 0,
        category1Name: "",
        category2Name: "",
        category1Id: 0,
        category2Id: 0,
        documentId: 0,
        documentFormat: "",
        numberFormat: "",
      },
      currentPage: 1,
      perPage: 20,
      totalCount: 0,
      userId: 0,
      isView: false,
    };
  }

  componentDidMount() {
    let _this = this;
    this.GetLedgersList();
    let user = localStorage.getItem("UserId");
    this.state.userId = user;
    this.setState({});
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }
  GetLedgersList = () => {
    const { currentPage, perPage } = this.state;
    let order = this.state.order === "asc" ? true : false;
    let apiUrl = `${API.GET_LEDGER}?sortBy=${this.state.sortBy}&isSortAscending=${order}`;
    this.setState({ isLedgerLoader: true, isLedgerFailed: false });
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        pageNumber: parseInt(currentPage),
        pagesize: parseInt(perPage),
      },
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.ledgerList = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.setState({}, () => {
            this.GetCategory1List(true);
          });
        }
      })
      .catch((error) => {
        this.setState({ isLedgerLoader: false, isLedgerFailed: false });

        logoutFunction(error?.response?.status);
      });
  };
  handleLedgerInputChange(e, field, type) {
    SelectedValue = false;
    if (type === "Add") {
      if (e.target.value === "") {
        if (field === "category1Name") {
          this.state.category1Error = false;
          this.state.AddLedgerDetails.category1Name = e.target.value;
          this.state.AddLedgerDetails.category1Id = 0;
          this.setState({});
        } else if (field === "category2Name") {
          this.state.category2Error = false;
          this.state.AddLedgerDetails.category2Name = e.target.value;
          this.state.AddLedgerDetails.category2Id = 0;
          this.setState({});
        } else if (field === "documentFormat") {
          this.state.documentFormatError = false;
          this.state.AddLedgerDetails.documentFormat = e.target.value;
          this.setState({});
        }
      } else {
        if (field === "category1Name") {
          this.state.category1Error = false;
          this.state.AddLedgerDetails.category1Name = e.target.value;
          this.state.AddLedgerDetails.category1Id = 0;
          this.setState({});
        } else if (field === "category2Name") {
          this.state.category2Error = false;
          this.state.AddLedgerDetails.category2Name = e.target.value;
          this.state.AddLedgerDetails.category2Id = 0;
          this.setState({});
        } else if (field === "documentFormat") {
          this.state.documentFormatError = false;
          this.state.AddLedgerDetails.documentFormat = e.target.value;
          this.setState({});
        }
      }
    } else if (type === "Edit") {
      if (field === "documentFormat") {
        this.state.documentFormatError = false;
        this.state.LedgerDetails.documentFormat = e.target.value;
        this.setState({});
      }
    }
  }
  handleSelectChange(value, field) {
    SelectedValue = true;
    if (field === "category1Name") {
      this.state.AddLedgerDetails[field] = value;
      this.state.AddLedgerDetails.category2Name = null;
      this.setState({}, () => {
        this.GetCategory2List(
          this.state.AddLedgerDetails.category1Name?.value,
          true
        );
      });
    } else {
      this.state.AddLedgerDetails[field] = value;
      this.setState({});
    }
    if (field === "category1Name") {
      this.state.category1Error = false;
      this.setState({});
    } else if (field === "category2Name") {
      this.state.category2Error = false;
      this.setState({});
    }
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 350) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 315) {
      this.state.isCancelMobile = true;
    } else {
      this.state.isCancelMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    this.state.height = window.innerHeight;
    this.setState({});
  };
  OpenLedgerScreen = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("addLedgerScreen")
    );
    myOffcanvas.show();
    this.state.ledgerArryList = [];
    this.setState({});
    this.GetCategory1List(true);
    $("body").addClass("scrollhide");
  };
  AddNewLedger = () => {
    const { AddLedgerDetails, userId } = this.state;
    if (
      AddLedgerDetails.category1Name?.value &&
      AddLedgerDetails.category2Name?.value &&
      AddLedgerDetails.documentFormat !== ""
    ) {
      let apiurl1 = `${API.EXIST_DOCUMENT_NUMBER_FORMAT}?name=${AddLedgerDetails.documentFormat}`;
      this.setState({ isLedgerLoader: true, isLedgerFailed: false });
      axios({
        method: "GET",
        url: apiurl1,
      }).then((res) => {
        if (res.data === false) {
          this.setState({ isLedgerLoader: true, isLedgerFailed: false });
          let apiUrl = `${API.POST_LEDGER}?userId=${userId}`;
          axios({
            method: "POST",
            url: apiUrl,
            data: [
              {
                id: AddLedgerDetails.id,
                category1Name: AddLedgerDetails.category1Name.label,
                category2Name: AddLedgerDetails.category2Name.label,
                category1Id: AddLedgerDetails.category1Name.value,
                category2Id: AddLedgerDetails.category2Name.value,
                documentId: AddLedgerDetails.documentId,
                documentFormat: AddLedgerDetails.documentFormat,
                numberFormat: "",
              },
            ],
          })
            .then((res) => {
              if (res.status === 200) {
                this.ClearAddledgerdetails();
                this.state.ledgerArryList = [];
                this.state.categoryArrayList = [];
                this.state.category1Error = false;
                this.state.category2Error = false;
                this.state.documentFormatError = false;
                this.setState({}, () => {
                  this.GetLedgersList();
                });
                toast.success("Document number format added successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                });
              }
            })
            .catch((error) => {
              this.setState({ isLedgerLoader: false, isLedgerFailed: false });

              logoutFunction(error?.response?.status);
            });
        } else {
          this.setState({ isLedgerLoader: false, isLedgerFailed: false });
          toast.error(
            "This document number format already exist for another category.Please give a different format for this category.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      });
    } else if (
      !AddLedgerDetails.category1Name &&
      !AddLedgerDetails.category2Name &&
      AddLedgerDetails.documentFormat === ""
    ) {
      this.state.category1Error = true;
      this.state.category2Error = true;
      this.state.documentFormatError = true;
      this.setState({});
    } else if (!AddLedgerDetails.category1Name) {
      this.state.category1Error = true;
      this.setState({});
    } else if (!AddLedgerDetails.category2Name) {
      this.state.category2Error = true;
      this.setState({});
    } else if (AddLedgerDetails.documentFormat === "") {
      this.state.documentFormatError = true;
      this.setState({});
    }
  };
  UpdateLedger = () => {
    const { LedgerDetails, userId } = this.state;
    if (LedgerDetails.documentFormat !== "") {
      let apiurl1 = `${API.EXIST_DOCUMENT_NUMBER_FORMAT}?name=${LedgerDetails.documentFormat}`;
      this.setState({ isLedgerLoader: true, isLedgerFailed: false });
      axios({
        method: "GET",
        url: apiurl1,
      }).then((res) => {
        if (res.data === false) {
          let apiUrl = `${API.PUT_LEDGER}?userId=${userId}`;
          axios({
            method: "PUT",
            url: apiUrl,
            data: [
              {
                id: LedgerDetails.id,
                category1Name: LedgerDetails.category1Name, //LedgerDetails.category1Name.label,
                category2Name: LedgerDetails.category2Name, //LedgerDetails.category2Name.label,
                category1Id: parseInt(LedgerDetails.category1Id), // parseInt(LedgerDetails.category1Name.value),
                category2Id: parseInt(LedgerDetails.category2Id), //parseInt(LedgerDetails.category2Name.value),
                documentId: LedgerDetails.documentId,
                documentFormat: LedgerDetails.documentFormat,
                numberFormat: "",
              },
            ],
          }).then((res) => {
            if (res.status === 200) {
              this.ClearEditledgerdetails();
              this.GetLedgersList();
              toast.success("Document number format edited successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          });
        } else {
          this.setState({ isLedgerLoader: false, isLedgerFailed: false });
          toast.error(
            "This document number format already exist for another category.Please give a different format for this category.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      });
    } else if (LedgerDetails.documentFormat === "") {
      this.state.documentFormatError = true;
      this.setState({});
    }
  };
  GetCategory1List = (value) => {
    const { dispatch } = this.props;
    this.setState({ isLedgerLoader: true, isLedgerFailed: false });
    let apiUrl = `${API.GET_CATAGORY_DROPDOWN}?type=category1&isLedger=${value}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: "Category1List",
            data: res.data?.map((res) => {
              return {
                value: res.categoryId,
                label: res.categoryName,
              };
            }),
          });
          this.setState({}, () => {
            this.GetCategory2List(0, true);
          });
        }
      })
      .catch((error) => {
        this.setState({ isLedgerLoader: false, isLedgerFailed: false });

        logoutFunction(error?.response?.status);
      });
  };
  GetCategory2List = (id, value) => {
    const { dispatch } = this.props;
    let cateId = parseInt(id);
    let apiUrl = `${API.GET_CATAGORY_DROPDOWN}?type=category2&categry1Id=${cateId}&isLedger=${value}`;
    this.setState({ isLedgerLoader: true, isLedgerFailed: false });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          if (id === 0) {
            dispatch({
              type: "Category2List",
              data: [],
            });
          } else {
            dispatch({
              type: "Category2List",
              data: res.data
                ? res.data?.map((res) => {
                    return {
                      value: res.categoryId,
                      label: res.categoryName,
                    };
                  })
                : [],
            });
          }
          this.setState({ isLedgerLoader: false, isLedgerFailed: false });
        }
      })
      .catch((error) => {
        this.setState({ isLedgerLoader: false, isLedgerFailed: false });
        logoutFunction(error?.response?.status);
      });
  };
  GetParticularLedgerDetails(isview, id) {
    var ids = this.state.ledgerArryList;
    //var LedgerId = ids.toString();
    var LedgerId = parseInt(id) || parseInt(ids.toString());
    let apiUrl = `${API.GET_PARTICULAR_LEDGER}?ledgerId=${parseInt(LedgerId)}`;
    this.setState({ isLedgerLoader: true, isLedgerFailed: false });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          let ledger = {
            id: res.data.id,
            category1Name: res.data.category1Name,
            category2Name: res.data.category2Name,
            category1Id: res.data.category1Id,
            category2Id: res.data.category2Id,
            documentId: res.data.documentId,
            documentFormat: res.data.documentFormat,
            historyLog: res.data?.historyLog || [],
          };
          this.state.LedgerDetails = ledger;
          // this.state.isView = isview;
          this.setState({}, () => {});
          let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("editLedgerScreen")
          );
          myOffcanvas.show();
          $("body").addClass("scrollhide");
          this.setState({
            isLedgerLoader: false,
            isLedgerFailed: false,
            isView: isview,
          });
        }
      })
      .catch((error) => {
        this.setState({
          isLedgerLoader: false,
          isLedgerFailed: false,
          isView: false,
        });
        //logoutFunction(error?.response?.status);
      });
  }
  OpenRemoveLedgerModal = () => {
    var ids = this.state.categoryArrayList;
    let apiurl1 = `${API.IS_DOCUMENT_PRESENT_CAT}?type=category2`;
    this.setState({ isLedgerLoader: true, isLedgerFailed: false });
    axios({
      method: "POST",
      url: apiurl1,
      data: ids,
    })
      .then((res) => {
        if (res.data?.length === 0) {
          this.RemoveLedger();
        } else {
          this.setState({ isLedgerLoader: false, isLedgerFailed: false });
          toast.error(
            "You can’t remove document number format. when document exist inside the category.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      })
      .catch((error) => {
        this.setState({ isLedgerLoader: false, isLedgerFailed: false });
        logoutFunction(error?.response?.status);
      });
  };
  RemoveLedger = () => {
    var ids = this.state.ledgerArryList;
    let apiUrl = `${API.DELETE_LEDGER}`;
    axios({
      method: "DELETE",
      url: apiUrl,
      data: ids,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.ledgerArryList = [];
          this.state.categoryArrayList = [];
          this.setState({}, () => {
            this.GetLedgersList();
          });
          this.setState({ isLedgerLoader: false, isLedgerFailed: false });
          toast.success("Ledger deleted successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((error) => {
        this.setState({ isLedgerLoader: false, isLedgerFailed: false });
        logoutFunction(error?.response?.status);
      });
  };
  handleCheckbox = (x, cat1) => {
    const { ledgerArryList, categoryArrayList } = this.state;
    if (ledgerArryList?.length == 0) {
      ledgerArryList.push(x);
    } else {
      if (ledgerArryList && ledgerArryList.filter((i) => i == x)?.length == 1) {
        ledgerArryList?.map((i, ind) =>
          i == x ? ledgerArryList.splice(ind, 1) : ""
        );
      } else {
        ledgerArryList.push(x);
      }
    }
    if (categoryArrayList?.length == 0) {
      categoryArrayList.push(cat1);
    } else {
      if (
        categoryArrayList &&
        categoryArrayList.filter((i) => i == cat1)?.length == 1
      ) {
        categoryArrayList?.map((i, ind) =>
          i == cat1 ? categoryArrayList.splice(ind, 1) : ""
        );
      } else {
        categoryArrayList.push(cat1);
      }
    }
    this.setState({});
  };
  handleChangeChecked = (x, cat1) => {
    const { ledgerArryList, categoryArrayList } = this.state;
    if (ledgerArryList?.length == 0) {
      ledgerArryList.push(x);
    } else {
      if (ledgerArryList && ledgerArryList.filter((i) => i == x)?.length == 1) {
        ledgerArryList?.map((i, ind) =>
          i == x ? ledgerArryList.splice(ind, 1) : ""
        );
      } else {
        ledgerArryList.push(x);
      }
    }
    if (categoryArrayList?.length == 0) {
      categoryArrayList.push(cat1);
    } else {
      if (
        categoryArrayList &&
        categoryArrayList.filter((i) => i == cat1)?.length == 1
      ) {
        categoryArrayList?.map((i, ind) =>
          i == cat1 ? categoryArrayList.splice(ind, 1) : ""
        );
      } else {
        categoryArrayList.push(cat1);
      }
    }
    this.setState({});
  };
  find = (e) => {
    this.state.perPage = e.value;
    this.setState({ isLedgerLoader: true, isLedgerFailed: false });
    const selectedPage = 1;
    this.state.currentPage = selectedPage;
    this.setState({}, () => {
      this.GetLedgersList();
    });
  };
  handlePageChange = (pageNumber) => {
    this.state.currentPage = pageNumber;
    this.setState({}, () => {});
    this.GetLedgersList();
  };
  ClearAddledgerdetails = () => {
    const { dispatch } = this.props;
    $("#addLedgerScreen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    dispatch({ type: "Category2List", data: [] });
    this.state.AddLedgerDetails = {
      id: 0,
      category1Name: "",
      category2Name: "",
      category1Id: 0,
      category2Id: 0,
      documentId: 0,
      documentFormat: "",
      numberFormat: "",
    };
    this.state.category1Error = false;
    this.state.category2Error = false;
    this.state.documentFormatError = false;
    this.state.ledgerArryList = [];
    this.state.categoryArrayList = [];
    this.setState({});
  };
  ClearEditledgerdetails = () => {
    const { dispatch } = this.props;
    $("#editLedgerScreen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    this.state.category1Error = false;
    this.state.category2Error = false;
    this.state.documentFormatError = false;
    this.state.ledgerArryList = [];
    this.state.categoryArrayList = [];
    dispatch({ type: "Category2List", data: [] });
    this.setState({});
  };
  sortTable = (name) => {
    if (this.state.ledgerList?.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }
      this.state.currentPage = 1;
      this.setState({}, () => {
        this.GetLedgersList();
      });
    }
  };

  /*  sortTable = (name) => {
    let sortData =this.state.ledgerList; // Create a copy of the table data
    if(sortData?.length !==0 ){
    this.state.sortBy=name;
    this.setState({})
      if(this.state.sortBy === name) {
      if(this.state.order === "asc"){ 
         var ordernew = "desc"
         this.state.order=ordernew;
         this.setState({})
        }
        else { 
          var ordernew = "asc"
          this.state.order=ordernew;
          this.setState({})
        }
    
      }
    sortData.sort((a, b) => {
      let valueA = a[name];
      let valueB = b[name];
      if (name === "assignedDate" || name === "publishedDate"||name==="reviewDate"||name==="requestedDate")  {
          let dateA = new Date(a[name]); 
          let dateB = new Date(b[name]);
      
          if (this.state.order === 'asc') {
            return dateA.getTime() - dateB.getTime();
          } else {
            return dateB.getTime() - dateA.getTime();
          }
        }
          else if (typeof valueA === 'number' && typeof valueB === 'number') {
          // Numeric sorting
          if (this.state.order === 'asc') {
            return valueA - valueB;
          } else {
            return valueB - valueA;
         }
    
        } else {
            if (this.state.order === 'asc') {
              return valueA.localeCompare(valueB);
            } else {
              return valueB.localeCompare(valueA);
            }
          }
      });
      this.state.ledgerList=sortData;
      this.setState({}) 
    }
    }; */
  /* handleAuditLogData = () => {
      let myOffcanvas = new window.bootstrap.Offcanvas(
        document.getElementById("sideScreen")
      );
      myOffcanvas.show();
    } */

  render() {
    const {
      isLedgerFailed,
      isLedgerLoader,
      isMobile,
      isRadioMobile,
      isSmallMobile,
      ledgerArryList,
      ledgerList,
      AddLedgerDetails,
      currentPage,
      LedgerDetails,
      isCategory1EditHide,
      isCategory1AddHide,
      isCategory1DeleteHide,
      perPage,
      sortBy,
      order,
    } = this.state;
    let {
      classes,
      ledgerCommonSearchResult,
      menuToggle,
      category1List,
      Category2List,
    } = this.props;
    return (
      <>
        {$("#editLedgerScreen").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : $("#addLedgerScreen").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        <div className={`${isMobile ? "main-body-mobile" : "main-body"}`}>
          {isLedgerLoader && (
            <div className="spinner_overlay">
              <div className="loader">
                <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
              </div>
            </div>
          )}

          {isLedgerFailed && (
            <div className="spinner_overlay">
              <div className="loader">
                <span>Loading failed</span>
              </div>
            </div>
          )}
          {isMobile == true ? (
            <div className="head-fixed">
              <div className="mobile-head border-bottom w-100">
                <div className="col-12 mobile-title">Ledger</div>
              </div>
              <div
                className={`${
                  isMobile ? "common-mobilesubmenu" : "common-submenu"
                }`}
              >
                <div
                  className={`col-12 d-flex justify-content-start ${
                    isMobile ? "pl-10" : "pl-10"
                  } `}
                >
                  {ledgerArryList?.length === 0 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }`}
                        id="displaybuttoncolor"
                        onClick={() => this.OpenLedgerScreen()}
                      >
                        <img src={AddIcon} />{" "}
                        <span className={`subhead-span p-2`}>Add</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  {ledgerArryList?.length === 1 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        onClick={() => this.GetParticularLedgerDetails(false)}
                      >
                        <img src={EditIcon} />
                        <span className={`subhead-span p-2`}>Edit</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  {ledgerArryList?.length !== 0 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        id="displaybuttoncolor"
                        onClick={() => this.OpenRemoveLedgerModal()}
                      >
                        <img src={RemoveIcon} />
                        <span className={`subhead-span p-2`}>Remove</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="head-fixed">
              <div className="title">
                <img src={LedgerIcon} />
                <span className="pl-10 head-span mt-10">Ledger</span>
              </div>
              <div
                className={`${
                  isMobile ? "common-mobilesubmenu" : "common-submenu"
                }`}
              >
                <div
                  className={`col-12 d-flex justify-content-start ${
                    isMobile ? "pl-1" : "pl-10"
                  } `}
                >
                  {ledgerArryList?.length === 0 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }`}
                        id="displaybuttoncolor"
                        onClick={() => this.OpenLedgerScreen()}
                      >
                        <img src={AddIcon} />{" "}
                        <span className={`subhead-span p-2`}>Add</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  {ledgerArryList?.length === 1 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        onClick={() => this.GetParticularLedgerDetails(false)}
                      >
                        <img src={EditIcon} />
                        <span className={`subhead-span p-2`}>Edit</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  {ledgerArryList?.length !== 0 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        id="displaybuttoncolor"
                        onClick={() => this.OpenRemoveLedgerModal()}
                      >
                        <img src={RemoveIcon} />
                        <span className={`subhead-span p-2`}>Remove</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          )}
          <ToastContainer limit={1} />

          <div
            className={`${
              isMobile ? "favorite-mobile-table1 " : "favorite-table1 "
            }table-responsive  table-fixed-header table-responsive-height`}
            style={{ width: "100%" }}
          >
            {/* <div
            className={`${
              isMobile
                ? "favorite-mobile-table1 table-mobile-height"
                : "favorite-table1 table-height"
            } table-responsive position-relative`}
            style={{ width: "100%" }}
          ></div> */}
            <table className="table fileListTable2 table-borderless table-hover">
              <thead className="thead-sticky  thead-color">
                <tr>
                  <td className="wid-7"></td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("category1Name")}
                  >
                    <span>Category 1 </span>
                    {sortBy === "category1Name" && (
                      <img src={order === "asc" ? downArrow : upArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("category2Name")}
                  >
                    <span>Category 2 </span>
                    {sortBy === "category2Name" && (
                      <img src={order === "asc" ? downArrow : upArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("documentFormat")}
                  >
                    <span> Document number format</span>
                    {sortBy === "documentFormat" && (
                      <img src={order === "asc" ? downArrow : upArrow} alt="" />
                    )}
                  </td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {ledgerList?.length !== 0 ? (
                  ledgerList?.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor:
                          ledgerArryList?.filter((r) => r == item.id)?.length >
                          0
                            ? "#f3f2f1"
                            : "",
                      }}
                      onDoubleClick={() =>
                        this.handleChangeChecked(item.id, item.category2Id)
                      }
                    >
                      <td>
                        {/* style={{ verticalAlign: "bottom" }} */}
                        <input
                          type="checkbox"
                          name="request"
                          className="checkboxes t-input"
                          checked={
                            ledgerArryList?.filter((r) => r == item.id)
                              ?.length > 0
                              ? true
                              : false
                          }
                          onClick={() =>
                            this.handleCheckbox(item.id, item.category2Id)
                          }
                        />
                      </td>
                      <td>
                        <span
                          className="tableoverflowNo"
                          title={item.category1Name}
                        >
                          {" "}
                          {item.category1Name}
                        </span>
                      </td>
                      <td>
                        <span
                          className="tableoverflowNo"
                          title={item.category2Name}
                        >
                          {item.category2Name}
                        </span>
                      </td>
                      <td>
                        <span
                          className="tablefilename"
                          onClick={() =>
                            this.GetParticularLedgerDetails(true, item.id)
                          }
                          //style={{ textDecoration: "none" }}
                          title={item.documentFormat}
                        >
                          {item.documentFormat}
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="table-nodata">
                      {ledgerList && "No record found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div
            className={`${
              isMobile
                ? "common-mobilesubmenu mobile-pagination"
                : menuToggle
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
            } pb-2 pt-2`}
          >
            {ledgerList?.length !== 0 ? (
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="8%" className="p-3">
                      <div style={{ minWidth: "80px", maxWidth: "80px" }}>
                        <Select
                          options={paginglist}
                          defaultValue={paginglistDefault}
                          classNamePrefix="paging"
                          isSearchable={false}
                          menuPlacement={"top"}
                          menuPosition={"fixed"}
                          onChange={(e) => this.find(e)}
                        />
                      </div>
                    </td>
                    <td
                      width="92%"
                      className={`text-end ${
                        this.state.isCancelMobile ? "pagination-padd" : "p-3"
                      }`}
                    >
                      {this.state.isMobile ? (
                        <Pagination
                          prevPageText={
                            <>
                              {" "}
                              <img src={LeftArrowIcon} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={RightArrowIcon} />{" "}
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={1}
                          onChange={this.handlePageChange}
                          activePage={this.state.currentPage}
                          totalItemsCount={this.state.totalCount}
                          itemsCountPerPage={this.state.perPage}
                        />
                      ) : (
                        <Pagination
                          prevPageText={
                            <>
                              {" "}
                              <img src={LeftArrowIcon} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={RightArrowIcon} />{" "}
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={3}
                          onChange={this.handlePageChange}
                          activePage={this.state.currentPage}
                          totalItemsCount={this.state.totalCount}
                          itemsCountPerPage={this.state.perPage}
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : null}
          </div>
        </div>
        <div
          className="offcanvas offcanvas-end offcanvasStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="addLedgerScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3"
            }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title">
              Add ledger
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle ${
                isMobile ? "pr-0" : "pr-0"
              }`}
              style={{ backgroundColor: "white" }}
              onClick={() => this.ClearAddledgerdetails("Add")}
            >
              <img
                src={CrossIcon}
                className="cursor-pointer app-image-hover mb-1"
                height={14}
              />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 pt-0">
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${
                  isSmallMobile ? "" : "mt-2"
                }`}
              >
                <div className="">
                  <label
                    className={`d-flex m-0 mb-2 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img
                      className="properties-search-img"
                      src={SubCategoryIcon}
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      Category 1{" "}
                    </span>
                  </label>
                  <div
                    className={`${
                      this.state.category1Error === true ? "border-red" : ""
                    }`}
                  >
                    <Select
                      className={`text-12-normal`}
                      classNamePrefix="assigngroups"
                      value={AddLedgerDetails.category1Name}
                      options={category1List}
                      defaultValue={AddLedgerDetails.category1Name || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) =>
                        this.handleSelectChange(e, "category1Name")
                      }
                    />
                  </div>
                  {this.state.category1Error === true ? (
                    <span className="send-rework-label">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
              >
                <div className="">
                  <label
                    className={`d-flex m-0 mb-2 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img
                      className="properties-search-img"
                      src={SubCategoryIcon}
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      Category 2
                    </span>
                  </label>
                  <div
                    className={`${
                      this.state.category2Error === true ? "border-red" : ""
                    }`}
                  >
                    <Select
                      className={`text-12-normal`}
                      classNamePrefix="assigngroups"
                      value={AddLedgerDetails.category2Name}
                      options={Category2List}
                      defaultValue={AddLedgerDetails.category2Name || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) =>
                        this.handleSelectChange(e, "category2Name")
                      }
                    />
                  </div>
                  {this.state.category2Error === true ? (
                    <span className="send-rework-label">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
              >
                <div className="form-group">
                  <label
                    className={`label-text ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger"
                    }`}
                  >
                    <img className="properties-search-img" src={DateIcon} />{" "}
                    <span className="pl-10 properties-search-span">
                      Document number format
                    </span>
                  </label>
                  <input
                    onChange={(e) =>
                      this.handleLedgerInputChange(e, "documentFormat", "Add")
                    }
                    className="form-control border-radius shiptype-select mt-2 dropdown-height"
                    value={AddLedgerDetails.documentFormat}
                    maxLength={250}
                    style={{
                      fontSize: "12px",
                      borderColor:
                        this.state.documentFormatError === true
                          ? "#d12232"
                          : "",
                    }}
                  />

                  {this.state.documentFormatError === true ? (
                    <span className="send-rework-label">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>{" "}
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
              <button
                className={`btn btn-light input-group f-size-13 d-flex ${
                  isMobile ? "filter-nextMobilebtn ledgerbtn" : "filter-nextbtn"
                } p-2`}
                onClick={() => this.AddNewLedger()}
              >
                <img src={ButtonSubmitIcon} className="modal-img"></img>
                <span style={{marginTop:"3px"}} className="model-label pl-10 obsoletebtn">Submit</span>
              </button>
            </div>
          </div>
        </div>

        <div
          className={`offcanvas offcanvas-end offcanvasStyle ${
            this.state.isView ? "audit-offcanvas" : ""
          }`}
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="editLedgerScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3"
            }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title">
              {this.state.isView ? "Ledger" : "Edit Ledger"}
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle ${
                isMobile ? "pr-0" : "pr-0"
              }`}
              style={{ backgroundColor: "white" }}
              onClick={() => this.ClearEditledgerdetails()}
            >
              <img src={CrossIcon} className="cursor-pointer app-image-hover" />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 pt-0">
            {this.state.isView && (
              <button
                className={`displaybutton p-0 ${isSmallMobile ? "pl-5" : ""}`}
                id="displaybuttoncolor"
                onClick={() =>
                  this.GetParticularLedgerDetails(false, LedgerDetails.id)
                }
              >
                <img src={EditIcon} />
                <span className={`subhead-span p-2`}>Edit</span>
              </button>
            )}
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${
                  isSmallMobile ? "" : "mt-2"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img
                      className="properties-search-img"
                      src={SubCategoryIcon}
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      Category 1
                    </span>
                  </label>
                  <input
                    style={{ fontSize: "12px" }}
                    value={LedgerDetails.category1Name}
                    className="form-control border-radius shiptype-select mt-2 dropdown-height"
                    disabled={true}
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img
                      className="properties-search-img"
                      src={SubCategoryIcon}
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      Category 2
                    </span>
                  </label>
                  <input
                    style={{ fontSize: "12px" }}
                    value={LedgerDetails.category2Name}
                    className="form-control border-radius shiptype-select mt-2 dropdown-height"
                    disabled={true}
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
              >
                <div className="form-group">
                  <label
                    className={`label-text ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger"
                    }`}
                  >
                    <img className="properties-search-img" src={DateIcon} />{" "}
                    <span className="pl-10 properties-search-span">
                      Document number format
                    </span>
                  </label>
                  <input
                    onChange={(e) =>
                      this.handleLedgerInputChange(e, "documentFormat", "Edit")
                    }
                    className="form-control border-radius shiptype-select mt-2 dropdown-height"
                    value={LedgerDetails.documentFormat}
                    maxLength={250}
                    disabled={this.state.isView}
                    style={{
                      fontSize: "12px",
                      borderColor:
                        this.state.documentFormatError === true
                          ? "#d12232"
                          : "",
                    }}
                  />

                  {this.state.documentFormatError === true ? (
                    <span className="send-rework-label">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>{" "}
              </div>
            </div>
            {!this.state.isView && (
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                <button
                  className={`btn btn-light input-group f-size-13 d-flex ${
                    isMobile ? "filter-nextMobilebtn ledgerbtn" : "filter-nextbtn"
                  } p-2`}
                  // isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                  onClick={() => this.UpdateLedger()}
                >
                  <img src={ButtonSubmitIcon} className="modal-img"></img>
                  <span style={{marginTop:"3px"}} className="model-label pl-10 obsoletebtn">Submit</span>
                </button>
              </div>
            )}
            {this.state.isView && LedgerDetails?.historyLog?.length > 0 && (
              <div>
                <div className="">
                  <h6 className="modal-title">Audit log</h6>
                </div>
                <div className="audit-table-wrapper audit-scroll-css">
                  <table className="px-3 audit-table">
                    <thead>
                      <tr className="border-bottom">
                        <th className="p-rem">Action</th>
                        <th className="p-rem">Action By</th>
                        <th className="p-rem wid-45">Description</th>
                        <th className="p-rem">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {LedgerDetails?.historyLog.map((x) => (
                        <tr className="border-bottom">
                          <td className="p-rem">{x.action}</td>
                          <td className="p-rem">{x.actionBy}</td>
                          <td className="p-rem">{x.description}</td>
                          <td className="p-rem">
                            {moment
                              .utc(x.createdTime)
                              .local()
                              .format("DD-MMM-YYYY hh:mm A")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* <CommonSearch /> */}
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    ledgerCommonSearchResult: state.commonReducer.ledgerCommonSearchResult,
    sideMenu: state.commonReducer.sideMenu,
    category1List: state.commonReducer.Category1List,
    Category2List: state.commonReducer.Category2List,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Ledger));
